<template>
  <div class="wrap">
    <van-sticky>
      <van-nav-bar @click-left="onClickLeft" left-arrow :safe-area-inset-top="true" title="检测报告" />
    </van-sticky>
    <div class="pb40">
      <div v-for="(item,index) in testingRecord.experientialResult" :key="index" class="rich-text">{{ item }}</div>
    </div>
    <div class="preview">
      <img src="../../../assets/images/preview/1.png"/>
      <img src="../../../assets/images/preview/2.png"/>
      <img src="../../../assets/images/preview/3.png"/>
      <img src="../../../assets/images/preview/4.png"/>
      <!-- <img src="../../../assets/images/preview/5.png"/> -->
    </div>
    <!-- 解锁按钮 -->
    <div class="unlock">
      <span @click="buyClick">付费解锁完整版报告</span>
    </div>
  </div>
</template>
<script>
import { isWeiXin } from '@/utils/tools'
import { freeAuth, h5Free } from '@/api/testing-record'
import { Toast } from 'vant'
import { fetchRecord } from '../../../api/testing-record'
export default {
  data() {
    return {
      testingRecord: {},
      testingRecordId: '',
      richText: {}
    };
  },
  components: {
  },
  created() {
    this.init()
  },
  watch: {
    $route() {
      this.init()
    }
  },
  methods: {
    buyClick() {
      // 确认了，支付
      if (isWeiXin()) {
        // 公众号支付
        freeAuth({
          testingRecordId: this.testingRecordId
        }).then(res => {
          window.location.href = res
        })
      } else {
        // h5支付
        h5Free({
          testingRecordId: this.testingRecordId
        }).then(res => {
          this.payOrderId = res.id
          localStorage.setItem('payOrderId', res.id)
          localStorage.setItem('testingRecordId', this.testingRecordId)
          // 保存
          if (res.state.key == 'Succeed') {
            window.href.reload()
          } else {
            // 跳转支付
            location.href = res.payJson + '&redirect_url=' + encodeURIComponent(location.href.replace('free-report', 'testing-record') + '&t=' + new Date().getMilliseconds())
          }
        })
      }
    },
    onClickLeft() {
      // history.back()
      this.$router.push({
        path: '/testing-record',
        query: {}
      })
    },
    init() {
      this.testingRecordId = this.$route.query.testingRecordId
      if (this.testingRecordId) {
        fetchRecord({
          testingRecordId: this.testingRecordId
        }).then(res => {
          this.testingRecord = res
          // 打开体验链接
          // window.location.href = res.experientialUrl
        })
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import url('../../../assets/css/style.css');
.rich-text {
  border-radius: 16px;
  margin-top: 40px;
  background: #fff;
  font-size: 0.38rem;
  padding: 40px;
}
.preview {
  img {
    width: 100%;
  }
}
.unlock {
  position: fixed;
  bottom: 120px;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  span {
    background: #ff9e19;
    font-size: 0.38rem;
    color: #fff;
    padding: 16px 40px;
    border-radius: 40px;
  }
}
</style>